window.MultipleApplyWizardForm = function ($scope) {
    var self = this;
    var formName = "multiple-apply-wizard-form";
    var _protected = BaseForm.call(self, formName, $scope);


    self.activeStepIndex = 0;
    self.steps = [];
    self.activeStep = '';


    self.load = function (formData) {
        self.steps = formData.steps;
        self.activeStep = formData.activeStep;
        self.activeStepIndex = self.steps.findIndex(function (step) {
            return step.code === self.activeStep;
        });
    };

    self.save = function (brandId) {

    };

    self.validator.validateCustom = function (field, optionsField, rule, showError, callback) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
        }
    };
};
